export default __webpack_public_path__ + "static/media/sloarmc.a648af37.png";